var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6737 13.0623L14.5099 11.2454C14.7182 11.023 15.0659 11.0089 15.2904 11.2171L19.2573 14.9091C19.5424 15.176 17.9387 17.1364 17.5849 17.3022C15.9815 18.0604 11.6425 19.1502 5.55864 13.2362C-1.14394 6.72161 0.162202 3.26619 1.12058 1.9742C1.3167 1.70933 3.25797 -0.0957897 3.49857 0.128641L7.48372 3.83679C7.70613 4.04505 7.72029 4.39281 7.51203 4.61724L5.57481 6.79642C5.42519 6.95615 5.38475 7.18866 5.47169 7.38883C5.87203 8.31284 7.36217 10.9332 12.0327 13.1876C12.2511 13.2907 12.5099 13.2382 12.6737 13.0623Z",
    fill: "#00B8EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.be319d58f4c3931a6f7a2ff00efb1090.svg";
export { ForwardRef as ReactComponent };